export default {
    formId: 'userProfileForm',
    formField: {
        company_name: {
            name: "company_name",
            label: "Company"
        },
        dealer_code: {
            name: "dealer_code",
            label: "Dealer Code"
        },
        email_address: {
            name: "email_address",
            label: "Email Address"
        },
        first_name: {
            name: "first_name",
            label: "First Name"
        },
        last_name: {
            name: "last_name",
            label: "Last Name"
        },
        city: {
            name: "city",
            label: "City"
        },
        state: {
            name: "state",
            label: "State"
        },
        postal_code: {
            name: "postal_code",
            label: "Postal Code"
        },
        about_me: {
            name: "about_me",
            label: "About Me"
        },
    }
}